import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34bc00c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "score-item-quantity__label"
}
const _hoisted_2 = {
  key: 1,
  class: "score-item-quantity__field"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "score-item-quantity__field-label" }, "Anzahl", -1))
const _hoisted_4 = {
  key: 0,
  class: "score-item-quantity__value-readonly"
}
const _hoisted_5 = {
  key: 2,
  class: "score-item-quantity__range"
}
const _hoisted_6 = {
  key: 0,
  class: "score-item-quantity__field"
}
const _hoisted_7 = { class: "score-item-quantity__field-label" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "score-item-quantity__value-readonly"
}
const _hoisted_10 = {
  key: 1,
  class: "score-item-quantity__field"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "score-item-quantity__field-label" }, "bis", -1))
const _hoisted_12 = {
  key: 0,
  class: "score-item-quantity__value-readonly"
}

import { computed } from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'score-item-quantity',
  props: /*#__PURE__*/_mergeModels({
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "dateFrom": {},
    "dateFromModifiers": {},
    "dateTo": {},
    "dateToModifiers": {},
  }),
  emits: ["update:modelValue", "update:dateFrom", "update:dateTo"],
  setup(__props) {

  const props = __props;

  const value = _useModel(__props, "modelValue");
  const dateFrom = _useModel(__props, "dateFrom");
  const dateTo = _useModel(__props, "dateTo");

  // Im readonly-Modus (z. B. WBB-Bogen) leere Felder ausblenden statt einen
  // Bindestrich zu zeigen – dort liegen keine dokumentierten Mengen vor.
  const showCount = computed(() => !props.readonly || value.value != null);
  const showFrom = computed(() => !props.readonly || !!dateFrom.value);
  const showTo = computed(() => !props.readonly || !!dateTo.value);
  const showRange = computed(() => showFrom.value || showTo.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["score-item-quantity", {'score-item-quantity--extra-top-space': !!__props.label}])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    (showCount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (__props.readonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(value.value), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "number",
                min: "0",
                step: "1",
                class: "score-item-quantity__input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
              }, null, 512)), [
                [
                  _vModelText,
                  value.value,
                  void 0,
                  { number: true }
                ]
              ])
        ]))
      : _createCommentVNode("", true),
    (showRange.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (showFrom.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, [
                  _createTextVNode("von"),
                  (!__props.readonly)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " *"))
                    : _createCommentVNode("", true)
                ]),
                (__props.readonly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(dateFrom.value), 1))
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "date",
                      class: "score-item-quantity__date",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateFrom).value = $event))
                    }, null, 512)), [
                      [_vModelText, dateFrom.value]
                    ])
              ]))
            : _createCommentVNode("", true),
          (showTo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                (__props.readonly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(dateTo.value), 1))
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "date",
                      class: "score-item-quantity__date",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateTo).value = $event))
                    }, null, 512)), [
                      [_vModelText, dateTo.value]
                    ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})